import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyFieldText: {
		id: 'issue-field-atlas-project-readview-full.atlas-project.empty-field-text',
		defaultMessage: 'Add project',
		description: 'Text to indicate that a given issue field has no value set',
	},
	noAccessTooltip: {
		id: 'issue-field-atlas-project-readview-full.atlas-project.no-access-tooltip',
		defaultMessage:
			'You need edit permission on this private project to unlink it from this work item.',
		description: 'Tooltip to indicate that a given issue field is not editable',
	},
});
